import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import Pagination from '../Pagination'
import SubCategoryList from './SubCategoryList'
import SubCategoryEdit from './SubCategoryEdit'
import SubCategoryAdd from './SubCategoryAdd'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const PropertyCategory = () => {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'property_category_manager') ?? {}
  const [page, setPage] = useState(1)
  const [categoryAdd, setCategoryAdd] = useState(false)
  const [categoryEdit, setCategoryEdit] = useState(false)
  const [currentItem, setCurrentItem] = useState('')
  const [categoryView, setCurrentView] = useState(false)
  const [filterData, setFilterData] = useState({
    category: '',
    searchKey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })

  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })

  const [subcategoryList, setSubcategoryList] = useState([])
  const [sort, setSort] = useState({
    sort_key: 'createdAt',
    sort_type: 'desc'
  })

  const handleEdit = item => {
    setCurrentItem(item)
    setCategoryEdit(!categoryEdit)
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handleView = item => {
    setCurrentItem(item)
    setCurrentView(!categoryView)
  }

  const handleCategory = () => {
    setCategoryAdd(!categoryAdd)
  }

  const allSubCategory = async data => {
    try {
      const payload = {
        page,
        sortKey: sort.sort_key,
        sortType: sort.sort_type,
        keyword: filterData.searchKey?.trim()
      }
      console.log(sort)

      var path = apiPath.propertyCategoryList
      const result = await apiGet(path, payload)
      var response = result?.data?.results
      const resultStatus = result?.data?.success
      setSubcategoryList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }
  const handleChangeData = e => {
    setFilterData({ ...filterData, searchKey: e.target.value, isFilter: true })
    setPage(1)
  }
  useEffect(() => {
    allSubCategory()
  }, [page, sort, filterData])

  return (
    <>
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
                <label
                  for='default-search'
                  className='mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white'
                >
                  {t('O_SEARCH')}
                </label>
                <div className='flex'>
                  <div className='relative '>
                    <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                      <svg
                        aria-hidden='true'
                        className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        {!filterData?.searchKey && (
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                          />
                        )}
                      </svg>
                    </div>
                    <input
                      type='search'
                      id='default-search'
                      title=''
                      className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[300px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      placeholder={t('SEARCH_BY_KEYWORD')}
                      value={filterData?.searchKey}
                      required
                      onChange={e => handleChangeData(e)}
                    />
                  </div>
                  {subcategoryList?.length > 0 && (
                    <button
                      title='Add Property Category'
                      type='button'
                      className='bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap'
                      onClick={() =>
                        navigator.push('/property-categories-sequence')
                      }
                    >
                      <Link
                        to='/property-categories-sequence'
                        state={{ page_size: paginationObj?.totalItems }}
                      >
                        {t('ARRANGE_SEQUENCE')}
                      </Link>
                    </button>
                  )}
                  {(manager?.add || user?.role === 'admin') && (
                    <button
                      title='Add Property Category'
                      type='button'
                      className='bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap'
                      onClick={() => handleCategory()}
                    >
                      + {t('ADD_PROPERTY_CATEGORY')}
                    </button>
                  )}
                </div>
              </div>
            </form>

            <SubCategoryList
              subcategoryList={subcategoryList}
              page={page}
              allSubCategory={allSubCategory}
              handleEdit={handleEdit}
              handleView={handleView}
              currentItem={currentItem}
              categoryView={categoryView}
              setSort={setSort}
              sort={sort}
              manager={manager}
              paginationObj={paginationObj}
            />

            {categoryEdit && (
              <SubCategoryEdit
                allSubCategory={allSubCategory}
                handleEdit={handleEdit}
                currentItem={currentItem}
                subcategoryList={subcategoryList}
              />
            )}

            {categoryAdd && (
              <SubCategoryAdd
                categoryAdd={categoryAdd}
                allSubCategory={allSubCategory}
                handleCategory={handleCategory}
                subcategoryList={subcategoryList}
              />
            )}
            {paginationObj?.totalItems?.length !== 0 && (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default PropertyCategory
